// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"238":"a4c9f80d","955":"52baa365"}[chunkId] + ".chunk.css";
};